import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../hooks/useAuth';

interface AuthOutletProps {
  fallbackPath: string;
}

function AuthOutlet({ fallbackPath }: AuthOutletProps) {
  // Use the updated useAuth hook to get user and isLoading
  const { user, isLoading } = useAuth(); // Changed isLoadingUser to isLoading
  const location = useLocation();

  // If still loading the user state, render nothing or a loading indicator
  if (isLoading) {
    // You can return null, a loading spinner, or a simple message
    return <p>Loading authentication state...</p>; // Placeholder loading message
  }

  // If user is not authenticated, redirect to the fallback path, carrying the page and its
  // query there and back. A link's whole point is where it goes, and an emailed one — a
  // confirmation, a notification naming its account — is often opened in a browser that
  // isn't signed in to that account (docs/MultiAccountSessions.md §6). Home is where
  // sign-in goes anyway.
  if (!user) {
    const page = `${location.pathname}${location.search}${location.hash}`;
    const to = page === '/home' ? fallbackPath : `${fallbackPath}?returnTo=${encodeURIComponent(page)}`;
    return <Navigate to={to} replace />;
  }

  // If authenticated, render the child routes
  return <Outlet />;
}

export default AuthOutlet;
